module.exports = __webpack_public_path__ + "static/media/cp4in.b9f77093.png";